// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"LoginForm_loginForm__g59AN","inputs":"LoginForm_inputs__1ojds","buttons":"LoginForm_buttons__3gqec","link":"LoginForm_link__3JflN","forgot":"LoginForm_forgot__3SgU6"};